import useTipoVinculoPessoa from "core/features/shared/useTipoVinculoPessoa";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";

export interface SelectTipoVinculoPessoaProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
}

function SelectTipoVinculoPessoa({
  isInvalid,
  ...rest
}: SelectTipoVinculoPessoaProps) {
  const { isLoading, data } = useTipoVinculoPessoa();

  return (
    <SelectBaseAntd
      loading={isLoading}
      isInvalid={isInvalid}
      size="large"
      placeholder="Selecione"
      showSearch
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectTipoVinculoPessoa;
